var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeOpened = function SvgEyeOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.113 10.631c.32.426.617.883.887 1.369-4.358 7.845-15.641 7.845-20 0 .275-.494.577-.958.903-1.39L1.646 9.354l.708-.708 1.189 1.19c.848-.94 1.82-1.7 2.87-2.284L5.1 5.8l.8-.6 1.424 1.899a11.54 11.54 0 0 1 4.176-.972V4h1v2.127c1.42.06 2.83.38 4.148.96l.905-1.81.894.447-.902 1.805a11.172 11.172 0 0 1 2.933 2.33l1.43-1.237.655.756-1.45 1.253ZM3.197 12.058c4.074-6.435 13.532-6.435 17.606 0-4.074 6.435-13.532 6.435-17.606 0ZM12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z",
    fill: "#232837"
  })));
};

export default SvgEyeOpened;